import { type InputHTMLAttributes, useId } from 'react';
import { cx } from './cx';

export interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string | undefined;
  mono?: boolean;
}

/** Campo de texto com alvo de toque grande e rótulo sempre visível (sem placeholder-only). */
export function TextField({ label, error, mono = false, id, className, ...rest }: TextFieldProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;

  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={inputId} className="text-sm font-medium text-ink-muted">
        {label}
      </label>
      <input
        id={inputId}
        className={cx(
          'min-h-[52px] rounded-lg border border-line bg-surface px-4 text-[16px] text-ink',
          'placeholder:text-ink-faint focus-visible:border-accent',
          mono && 'font-mono tabular-money',
          error && 'border-danger',
          className,
        )}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${inputId}-error` : undefined}
        {...rest}
      />
      {error ? (
        <p id={`${inputId}-error`} className="text-sm text-danger">
          {error}
        </p>
      ) : null}
    </div>
  );
}
